import type { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { HtmlClassExtension } from '../../../extensions/html-class';
import { NodeName } from '../../../schema/nodes';

export class BulletListNode implements NodeSpec {
  public static readonly nodeName = NodeName.BulletList;
  public static is(node: ProsemirrorNode) {
    return node.type.name === BulletListNode.nodeName;
  }
  private readonly htmlClassExtension: HtmlClassExtension;
  public attrs = {
    ...(this.config?.withHtmlClass && HtmlClassExtension.attrs),
  };
  public content = 'list_item+';
  public group = 'block';
  public parseDOM = [
    {
      tag: 'ul',
      getAttrs: (dom: HTMLElement) => ({
        ...(this.htmlClassExtension && this.htmlClassExtension.parseDOMGetAttrs(dom)),
      }),
    },
  ];

  constructor(
    private config?: {
      withHtmlClass?: boolean;
    },
  ) {
    if (config?.withHtmlClass) {
      this.htmlClassExtension = new HtmlClassExtension();
    }
  }

  public toDOM = (node: ProsemirrorNode): DOMOutputSpec => {
    let attributes = {};
    if (this.htmlClassExtension) {
      const htmlClass = this.htmlClassExtension.getClassSerialization(node);
      if (htmlClass) {
        attributes = {
          ...attributes,
          class: htmlClass,
        };
      }
    }
    return ['ul', attributes, 0];
  };
}
